import ExampleCodeBlock from 'components/Docs/ExampleCodeBlock'

const npm = `npm install @integration-app/react`

export function InstallReactSdkCodeExample() {
  return <ExampleCodeBlock customCodes={{ npm }} />
}
